import apiFetch from '../apiFetch'

export default function (token, directionOUId) {
  return apiFetch({ endPoint: `OrganizedUnit/DirectionOU/${directionOUId}`, method: 'DELETE', body: null, token: token })
}
